<template>
  <Teleport to="body">
    <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
      @click="handleBackdropClick">
      <div
        class="flex flex-col md:flex-row bg-white rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden max-h-[90vh]"
        @click.stop>
        <!-- Image - Cachée sur mobile, visible sur desktop -->
        <div class="hidden md:flex md:w-1/5 bg-white items-end justify-center pb-0">
          <img src="@/assets/images/charactere.png" alt="Conseiller"
            class="w-full max-w-[400px] object-contain select-none pointer-events-none" />
        </div>

        <!-- Contenu -->
        <div class="w-full md:w-4/5 p-4 sm:p-6 bg-white flex flex-col overflow-y-auto">
          <h2
            class="text-center text-green-700 text-lg sm:text-xl md:text-2xl font-bold uppercase mb-6 md:mb-8 underline decoration-2 underline-offset-4">
            {{ content.title }}
          </h2>

          <div class="space-y-4 md:space-y-5 text-gray-800 text-sm sm:text-[15px] md:text-base leading-relaxed flex-1">
            <p v-for="(paragraph, index) in content.paragraphs" :key="index">
              {{ paragraph }}
            </p>
          </div>

          <div class="flex justify-center sm:justify-end mt-6 md:mt-8">
            <button @click="$emit('close')"
              class="w-full sm:w-auto px-8 py-3 bg-[#04406E] text-white font-semibold text-sm rounded-[15px] hover:bg-[#033557] focus:ring-4 focus:ring-blue-300 shadow-lg transition-all duration-200">
              Je continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { watch, ref, onMounted } from 'vue'

const props = defineProps<{ show: boolean }>()
const emit = defineEmits(['close'])

// Contenu du modal chargé depuis JSON
const content = ref<{ title: string; paragraphs: string[] }>({
  title: '',
  paragraphs: []
})

// Charger le contenu JSON au montage
onMounted(async () => {
  try {
    const response = await fetch(`${import.meta.env.BASE_URL}data/modal-avis.json`)
    const data = await response.json()
    content.value = data
  } catch (error) {
    console.error('Erreur lors du chargement du contenu:', error)
    // Contenu par défaut en cas d'erreur
    content.value = {
      title: 'AVIS IMPORTANT À LIRE ATTENTIVEMENT',
      paragraphs: ["Erreur de chargement du contenu."]
    }
  }
})

// Gère le scroll du body en fonction de l'état du modal
watch(
  () => props.show,
  (newValue) => {
    if (newValue) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  },
  { immediate: true }
)

const handleBackdropClick = (event: MouseEvent) => {
  if ((event.target as HTMLElement).classList.contains('fixed')) {
    emit('close')
  }
}
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>